import { KeyValue } from "@/main/models/common";

export enum AssessmentTypeTypes {
	GET_ASSESSMENT_TYPE = "@assessmentType/GET_ASSESSMENT_TYPE",
	SAVE_ASSESSMENT_TYPE = "@assessmentType/SAVE_ASSESSMENT_TYPE",
	RESET_REDUCER_ASSESSMENT_TYPE = "@assessmentType/RESET_REDUCER_ASSESSMENT_TYPE",
}

export interface AssessmentTypeState {
	readonly assessmentType: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetAssessmentType {
	type: typeof AssessmentTypeTypes.GET_ASSESSMENT_TYPE;
}

export interface SaveAssessmentType {
	type: typeof AssessmentTypeTypes.SAVE_ASSESSMENT_TYPE;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerAssessmentType {
	type: typeof AssessmentTypeTypes.RESET_REDUCER_ASSESSMENT_TYPE;
}

export type AssessmentTypeActionTypes = GetAssessmentType | SaveAssessmentType | ResetReducerAssessmentType;
